//针对后台部分字段{code:'',desc:''}情况
export const useResponseUtil = {
  /**
   * code内容
   */
  code: val => {
    return val ? val.code : null
  },

  /**
   * desc内容
   */
  desc: val => {
    return val ? val.desc : null
  },

  /**
   * 获取指定格式
   */
  get: val => {
    return {
      code: val,
      desc: ''
    }
  }
}
